import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { forViewer, invitationsQuery, viewerIdOf } from "../services/queries";

export const useInvitations = () => {
  const { user, token } = useAuth();
  const orgId = user?.schoolId || user?.orgId;

  return useQuery({
    ...forViewer(invitationsQuery(orgId, token), viewerIdOf(user)),
    enabled: !!orgId && !!token,
  });
};
